import { render, staticRenderFns } from "./LensListItem.vue?vue&type=template&id=4b23734d&scoped=true"
import script from "./LensListItem.vue?vue&type=script&lang=js"
export * from "./LensListItem.vue?vue&type=script&lang=js"
import style0 from "./LensListItem.vue?vue&type=style&index=0&id=4b23734d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b23734d",
  null
  
)

export default component.exports